import React from 'react';
import useMakeRoadmapForm from './MakeRoadmapForm';
import {
  Button,
  ButtonColor,
  ButtonSize,
  useMassUpdateServiceRequired
} from 'ui-builder';

export default function MakeRoadmapButton() {
  const massUpdateService = useMassUpdateServiceRequired();

  const form = useMakeRoadmapForm();

  return (
    <Button
      text="Roadmap"
      isDisabled={massUpdateService.getCheckedIds().length === 0}
      onClick={() => {
        form.openForm();
      }}
      color={ButtonColor.DARK_BLUE}
      size={ButtonSize.SMALL}
      isFlat
      isFilled
    />
  );
}
